import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    initialFilter: {},
    currentFilter: {},

    switchState: {},
    top2BoxToggle: true,
    productList: [],
};

export const respondentDashboardStore = createSlice({
    name: "respondentDashboardStore",
    initialState,
    reducers: {
        loadSwitchState: (state, action) => {
            state.switchState = action.payload;
        },
        loadInitialFilterState: (state, action) => {
            state.initialFilter = action.payload;
        },
        loadCurrentFilterState: (state, action) => {
            state.currentFilter = action.payload;
        },
        loadTop2BoxToggleState: (state, action) => {
            state.top2BoxToggle = action.payload;
        },
        loadProductListState: (state, action) => {
            state.productList = action.payload;
        },
        // Add the reset action here
        resetRespondentDashboardStoreState: () => initialState,
    },
});

export const { loadSwitchState, loadInitialFilterState, loadCurrentFilterState, loadTop2BoxToggleState, loadProductListState, resetRespondentDashboardStoreState } = respondentDashboardStore.actions;

export default respondentDashboardStore.reducer;
